module.exports = __webpack_public_path__ + "img/frprogressImg.27823268.png";